import { useCallback, useLayoutEffect, useState } from 'react';

export const useIsOverflowing = (ref?: React.RefObject<HTMLElement>): boolean => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = useCallback(() => {
    const element = ref?.current;
    if (element) {
      setIsOverflowing(element.scrollWidth > element.clientWidth);
    }
  }, [ref]);

  useLayoutEffect(() => {
    if (!ref?.current) return;
    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [checkOverflow, ref]);

  return isOverflowing;
};
